import type { FeatureCollection } from "geojson";
import type { LayerDescriptor } from "../../shared-components/feature-table/feature-table.types";
import { Viewerlayer } from "../model/viewerlayer";
import type { BaseViewerService } from "../services/internal-services/viewer-services/base-viewer.service";

/** True when the layer has in-memory GeoJSON features — the only kind the feature-table/detail panels can show. */
export function hasLayerFeatureData(layer: Viewerlayer): boolean {
  return (layer.source?.features?.features?.length ?? 0) > 0;
}

/** Builds a data-source-agnostic LayerDescriptor from a Viewerlayer, wired to viewerService for persistence. */
export function buildLayerDescriptor(layer: Viewerlayer, viewerService: BaseViewerService): LayerDescriptor {
  const snapshot = [...(layer.source?.features?.features ?? [])] as FeatureCollection["features"];
  return {
    layerName: layer.name,
    layerType: layer.overlayType,
    totalFeatures: snapshot.length,
    sourceEpsg: 3857,
    loadPage: (page, pageSize) => {
      const start = page * pageSize;
      return Promise.resolve({
        type: "FeatureCollection",
        features: snapshot.slice(start, start + pageSize),
      } as FeatureCollection);
    },
    getAllFeatures: () => snapshot,
    updateFeatureProperties: () => viewerService.updateUserLayer(layer),
    collectionProperties: layer.source?.features?.properties,
    updateCollectionProperties: (properties) => {
      if (layer.source?.features) layer.source.features.properties = properties;
      viewerService.updateUserLayer(layer);
    },
  };
}
